module.exports = __webpack_public_path__ + "static/media/right_candy_cane_sm.638cec1d.svg";